
export const EXCEEDED_MAX_RED_COUNT = "ExceededMaxRedCount";

